<template>
    <div class="single-header">
        <secondary-header :title="lang('Genealogy')" backRoute="default" :menuButton="false"></secondary-header>

        <main>
            <div class="container">
                <div class="row justify-content-center digital-card">
                    <div class="col-lg-10 py-3 px-1">
                        <div class="d-flex mb-3 px-2">
                            <div class="d-flex">
                                <img :src="merchant_branch.branch_logo ? merchant_branch.branch_logo : merchant.merchant_logo" alt="" class="logo m-auto" style="max-width: 100%; max-height: 7rem;">
                            </div>
                            <div class="flex-fill d-flex a pl-2">
                                <h4 class="m-auto text-center">{{ merchant_branch.name }}</h4>
                            </div>
                        </div>
                        <div class="genealogy-list">
                            <div class="level-1">
                                <div class="card pt-3" :style="'background-color:'+ ((genealogies.level_1 && genealogies.level_1.is_current_user) ? genealogy_settings.color_self : genealogy_settings.color_level_1) +';'">
                                    <div v-if="genealogies.level_1" class="card-body p-2" @click="changeFocus(genealogies.go_up_id)">
                                        <font-awesome-icon icon="chevron-up" size="lg" class="go-up"></font-awesome-icon>
                                        <font-awesome-icon icon="genderless" size="2x" :class="'gender '+ genealogies.level_1.gender"></font-awesome-icon>
                                        <div v-for="(text_content, i) in genealogy_settings.text_contents" :key="i" :class="'text-'+ text_content.align">
                                            <div v-if="genealogies.level_1[text_content.text_left]" class="text-value">{{ genealogies.level_1[text_content.text_left] }}</div>
                                            <div v-if="genealogies.level_1[text_content.text_centre]" class="text-value">{{ genealogies.level_1[text_content.text_centre] }}</div>
                                            <div v-if="genealogies.level_1[text_content.text_right]" class="text-value">{{ genealogies.level_1[text_content.text_right] }}</div>
                                        </div>
                                    </div>
                                    <div v-else-if="!state.loading_resource" class="card-body p-2 pl-4 text-center">
                                        {{ lang('No Grandfather Data') }}
                                    </div>
                                </div>

                                <div v-for="level_2 in genealogies.level_2" :key="'genealogy-'+ level_2.id" class="level-2 pl-4">
                                    <div class="card pr-4 my-2" :style="'background-color:'+ (level_2.is_current_user ? genealogy_settings.color_self : genealogy_settings.color_level_2) +';'">
                                        <font-awesome-icon v-if="level_2.gender" icon="genderless" size="2x" :class="'gender '+ level_2.gender"></font-awesome-icon>
                                        <div v-if="level_2.id" class="card-body p-2">
                                            <div v-for="(text_content, i) in genealogy_settings.text_contents" :key="i" :class="'text-'+ text_content.align">
                                                <div v-if="level_2[text_content.text_left]" class="text-value">{{ level_2[text_content.text_left] }}</div>
                                                <div v-if="level_2[text_content.text_centre]" class="text-value">{{ level_2[text_content.text_centre] }}</div>
                                                <div v-if="level_2[text_content.text_right]" class="text-value">{{ level_2[text_content.text_right] }}</div>
                                            </div>
                                        </div>
                                        <div v-else-if="!state.loading_resource" class="card-body p-2 pl-4 text-center">
                                            {{ lang('No Father Data') }}
                                        </div>
                                    </div>

                                    <div v-for="level_3 in level_2.childrens" :key="'genealogy-'+ level_3.id" class="level-3 pl-4">
                                        <div
                                            class="card pr-4 my-2"
                                            :class="{focus: genealogy_id == level_3.id}"
                                            :style="'background-color:'+ (level_3.is_current_user ? genealogy_settings.color_self : genealogy_settings.color_level_3) +';'"
                                            @click="$set(level_3, 'show_child', !level_3.show_child)"
                                        >
                                            <font-awesome-icon icon="genderless" size="2x" :class="'gender '+ level_3.gender"></font-awesome-icon>
                                            <div class="card-body p-2">
                                                <div v-for="(text_content, i) in genealogy_settings.text_contents" :key="i" :class="'text-'+ text_content.align">
                                                    <div v-if="level_3[text_content.text_left]" class="text-value">{{ level_3[text_content.text_left] }}</div>
                                                    <div v-if="level_3[text_content.text_centre]" class="text-value">{{ level_3[text_content.text_centre] }}</div>
                                                    <div v-if="level_3[text_content.text_right]" class="text-value">{{ level_3[text_content.text_right] }}</div>
                                                </div>
                                            </div>
                                            <template v-if="level_3.total_child > 0">
                                                <font-awesome-icon v-if="level_3.show_child" icon="chevron-up" size="lg" class="go-down"></font-awesome-icon>
                                                <font-awesome-icon v-else icon="chevron-down" size="lg" class="go-down"></font-awesome-icon>
                                            </template>
                                        </div>

                                        <div class="level-4 pl-4" :class="{'show': level_3.show_child}">
                                            <div v-for="level_4 in level_3.childrens"
                                                :key="'genealogy-'+ level_4.id"
                                                class="card pr-4 my-2"
                                                :style="'background-color:'+ (level_4.is_current_user ? genealogy_settings.color_self : genealogy_settings.color_level_4) +';'"
                                                 @click="level_4.total_child > 0 ? changeFocus(level_4.id) : ''"
                                            >
                                                <font-awesome-icon icon="genderless" size="2x" :class="'gender '+ level_4.gender"></font-awesome-icon>
                                                <div class="card-body p-2">
                                                    <div v-for="(text_content, i) in genealogy_settings.text_contents" :key="i" :class="'text-'+ text_content.align">
                                                        <div v-if="level_4[text_content.text_left]" class="text-value">{{ level_4[text_content.text_left] }}</div>
                                                        <div v-if="level_4[text_content.text_centre]" class="text-value">{{ level_4[text_content.text_centre] }}</div>
                                                        <div v-if="level_4[text_content.text_right]" class="text-value">{{ level_4[text_content.text_right] }}</div>
                                                    </div>
                                                </div>
                                                <font-awesome-icon v-if="level_4.total_child > 0" icon="chevron-down" size="lg" class="go-down"></font-awesome-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div v-if="!state.loading_resource && genealogies.length == 0" class="text-center py-5">{{ lang('No data available') }}</div> -->
                    </div>
                </div>
            </div>

            <loader v-if="(state.loading || state.loading_resource) && !genealogies.level_2" />
        </main>
    </div>
</template>

<script>
export default {
    props: ['merchant_member_id'],

    data() {
        return {
            genealogies: {},
            old_genealogies: {},
            genealogy_settings: {},
            merchant: {
                merchant_logo: this.$route.query.merchant_logo_url,
            },
            merchant_branch: {
                branch_logo: this.$route.query.merchant_logo_url,
            },
            genealogy_id: this.$route.query.genealogy_id,
        }
    },

    methods: {
        getResource() {
            this.$set(this.state, 'loading_resource', true)
            this.old_genealogies = JSON.parse(JSON.stringify(this.genealogies))
            axios.post(this.GLOBAL.API_BASE_URL +"digital-card/"+ this.merchant_member_id + "/genealogy", {
                    genealogy_id: this.genealogy_id
                })
                .then(response => {
                    this.genealogies = response.data.genealogy_data
                    this.genealogy_settings = response.data.genealogy_settings
                    this.merchant = response.data.merchant
                    this.merchant_branch = response.data.merchant_branch
                })
                .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
                .finally(() => this.$set(this.state, 'loading_resource', false))
        },

        changeFocus(genealogy_id) {
            this.genealogy_id = genealogy_id
            this.getResource()
        },
    },

    created() {
        this.getResource()
    },

    beforeRouteLeave(to, from, next) {
        to.params.member_active_index = this.$route.query.member_active_index
        next()
    }
}
</script>

<style lang="scss" scoped>
    .genealogy-container {
        position: relative;
    }

    .genealogy-list {
        &.old {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;


        }
    }

    .text-LEFT {
        display: flex;
        div {
            margin-right: 1rem;
        }
    }
    .text-RIGHT {
        display: flex;
        justify-content: right;
        div {
            margin-left: 1rem;
        }
    }
    .text-CENTRE {
        display: flex;
        justify-content: center;
        div {
            margin-left: 1rem;
            margin-right: 1rem;
        }
    }
    .text-JUSTIFY {
        display: flex;
        > div:not(:first-child):not(:last-child) {
            margin: auto;
        }
        > div:first-child {
            margin-right: auto;
        }
        > div:last-child {
            margin-left: auto;
        }
    }

    .card {
        position: relative;
        min-height: 3.5rem;
        z-index: 12;
        box-shadow:
            0 3px 3px -2px var(--v-shadow-key-umbra-opacity,rgba(0, 0, 0, .2)),
            0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .14)),
            0 1px 8px 0 var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, .12));

        &.focus {
            border: 1px #454545 solid;
            box-shadow:
                0 3px 5px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .2)),
                0 5px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .14)),
                0 1px 14px 0 var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, .12));
        }

        .gender {
            position: absolute;
            top: 0;
            right: 0.4rem;

            &.Male {
                color: #3490dc;
            }
            &.Female {
                color: #ff94f0;
            }
        }

        .go-up {
            position: absolute;
            top: 0;
            left: 0.4rem;
        }

        .go-down {
            position: absolute;
            bottom: 0;
            right: 0.4rem;
        }
    }

    .level-2 {
        &:not(:last-child) {
            position: relative;
            &::before {
                content: "";
                z-index: 9;
                position: absolute;
                border-left: 1px solid #c9c9c9;
                height: 100%;
                width: 1rem;
                left: calc(0.5rem + 1px);
                top: 0;
            }
        }
        
        .card {
            z-index: 11;
            &::before {
                content: "";
                z-index: 8;
                position: absolute;
                border-left: 1px solid #c9c9c9;
                border-bottom: 1px solid #c9c9c9;
                border-bottom-left-radius: 0.8rem;
                height: 100%;
                width: 1rem;
                left: -1rem;
                top: -50%;
            }
        }
    }

    .level-3 {
        &:not(:last-child) {
            position: relative;
            &::before {
                content: "";
                z-index: 8;
                position: absolute;
                border-left: 1px solid #c9c9c9;
                height: 100%;
                width: 1rem;
                left: calc(0.5rem + 1px);
                top: 0;
            }
        }

        .card {
            z-index: 10;
            &::before {
                content: "";
                z-index: 8;
                position: absolute;
                border-left: 1px solid #c9c9c9;
                border-bottom: 1px solid #c9c9c9;
                border-bottom-left-radius: 0.8rem;
                height: 100%;
                width: 1rem;
                left: -1rem;
                top: -50%;
            }
        }
    }
    
    .level-4 {
        display: none;
        &.show {
            display: block;
        }

        .card {

            &:not(:last-child) {
                position: relative;
                &::after {
                    content: "";
                    z-index: 8;
                    position: absolute;
                    border-left: 1px solid #c9c9c9;
                    height: 100%;
                    width: 1rem;
                    left: -1rem;
                    top: 0;
                }
            }

            z-index: 9;
            &::before {
                content: "";
                z-index: 8;
                position: absolute;
                border-left: 1px solid #c9c9c9;
                border-bottom: 1px solid #c9c9c9;
                border-bottom-left-radius: 0.8rem;
                height: 100%;
                width: 1rem;
                left: -1rem;
                top: -50%;
            }
        }
    }
</style>